(($) => {
  const triggredProductVariation = () => {
    const init = () => {
      execute();
      executeSimple();
    };

    const execute = () => {
      const el = {
        radio: ".js-product-variation",
      };

      if ($(el.radio).length === 0) return;

      $(document).on("input", el.radio, function () {
        const target = $(this).data("target");

        $(target).val($(this).val());
        $(target).trigger("change");
      });
    };

    const executeSimple = () => {
      const el = {
        radio: ".js-product-simple",
      };

      if ($(el.radio).length === 0) return;

      $(document).on("input", el.radio, function () {
        const target = $(this).data("target");

        $(target).val($(this).val());
        $(target).trigger("input");
      });
    };

    init();
  };

  try {
    triggredProductVariation();
  } catch (error) {
    console.error("triggredProductVariation", error);
  }
  // eslint-disable-next-line no-undef
})(jQuery);
